import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'getAge',
})
export class AgePipe implements PipeTransform {
  transform(value: string): number {
    const birthdate = new Date(value);
    const today = new Date();
    let age = today.getFullYear() - birthdate.getFullYear();
    const monthDiff = today.getMonth() - birthdate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthdate.getDate())) {
      age--;
    }
    return age;
  }
}
